import { render, staticRenderFns } from "./AlertTable.vue?vue&type=template&id=46b25c88&scoped=true&"
import script from "./AlertTable.vue?vue&type=script&lang=js&"
export * from "./AlertTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertTable.vue?vue&type=style&index=0&id=46b25c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b25c88",
  null
  
)

export default component.exports